export default __webpack_public_path__ + "static/media/maxSum.1973488c.png";